import type { ActionMessage, DispatchFunction } from 'satcheljs';
import { isDevToolsEnabled } from 'mini-diagnostics/lib/utils/isDevToolsEnabled';
import { satchelActionDispatched } from '../actions/satchelActionDispatched';

const DIAGNOSTICS_ACTION_PREFIX = '__DIAGNOSTICS';

const SKIP_ACTIONS = [
    'LOG_USAGE',
    'setTimeZoneRange',
    'MARK_IMPORT_AS_LOADED',
    'setFolderNodeViewState',
    'setPersonaBlobFetchStatus',
];

export const satchelDiagnosticsMiddleware = (next: DispatchFunction, action: ActionMessage) => {
    // Dispatching an action in the action processing middleware will cause an infinite loop
    // so we filter out the action type that we are about to dispatch.
    // Matching on the prefix __DIAGNOSTICS means that other diagnostics actions can also be
    // filtered out (if they follow the same naming convention) to reduce noise in the satchel
    // action diagnostics logs.
    if (isTrackingEnabled()) {
        requestAnimationFrame(() => {
            if (shouldTrackAction(action)) {
                // track actions with data-points
                // in-future add ability to track all actions?
                if (action.dp?.name) {
                    satchelActionDispatched({ type: action.type, payload: { dp: action.dp } });
                }
            }
        });
    }

    next(action);
};

export const legacySatchelDiagnosticsMiddleware = (
    next: Function,
    action: Object,
    actionType: string,
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    args: any,
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    actionContext: any
) => {
    // Same applies here as above. Legacy satchel actions have a slightly different shape.
    if (isTrackingEnabled() && actionType.indexOf(DIAGNOSTICS_ACTION_PREFIX) !== 0) {
        const loggedAction: ActionMessage = { type: actionType };

        // record actions that have an associated data-point
        if (actionContext?.datapoint) {
            loggedAction.payload = { dp: actionContext.datapoint };
            requestAnimationFrame(() => satchelActionDispatched(loggedAction));
        }
    }

    next(action, actionType, args, actionContext);
};

const isTrackingEnabled = isDevToolsEnabled;

const shouldTrackAction = (action: ActionMessage): boolean => {
    const track =
        action.type &&
        !SKIP_ACTIONS.includes(action.type) &&
        action.type.indexOf(DIAGNOSTICS_ACTION_PREFIX) !== 0;

    return track;
};
